module.exports = __webpack_public_path__ + "img/headervisual-1200-1x.0cb70810.jpg";